<template>
  <v-container fluid>
    <h1>{{get("header-1")}}</h1>
    <br />
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-img :src="image" class="image" alt="Window Image" left></v-img>
        </v-row>
        <v-row>
          <p>
            {{ get("p-1.1") }}
          </p>
        </v-row>
        <v-row :class="theme + '-alt-background-1'">
          <h2>{{ get("header-2") }}</h2>
          <p>
            {{ get("p-2.1") }}
          </p>
          <ol>
            <li>
              <strong>{{ get("p-2.2") }}</strong>
              {{ get("p-2.3") }}
            </li>
            <li>
              <strong>{{ get("p-2.4") }}</strong>
              {{ get("p-2.5") }}
            </li>
            <li>
              <strong>{{ get("p-2.6") }}</strong>
              {{ get("p-2.7") }}
            </li>
          </ol>
        </v-row>
        <h2>{{ get("header-3") }}</h2>
        <p>
          {{ get("p-3.1") }}
        </p>
        <h2>{{ get("header-4") }}</h2>
        <p>
          {{ get("p-4.1") }}
          <phonenumber phone="(303) 778-7663"></phonenumber> 
          {{ get("p-4.2") }}
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "window-home",

  components: {
    estimate,
    phonenumber,
  },

  created() {
    this.pageName = "windows";
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/windows-1.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>

.image {
  margin-bottom: 20px;
}
</style>
